<template>
  <section :class="style['details-page']">
    <div v-theme :class="style['details-page-header']">
      <icon-back
        :class="style['icon-back']"
        :style="{ fill: colorsStore.textColor }"
        @click="clickBack()"
      ></icon-back>
      <p :class="style['header-text']" :style="headerColor">{{ headerText }}</p>
    </div>
    <div :class="style['details-page-main']">
      <p v-if="error" :class="style['error-text']">
        <span v-for="(errorText, index) in error" :key="index">{{ errorText }}</span>
      </p>
      <component :is="detailsPageStore.isDetailsPageShown" />
    </div>
  </section>
</template>

<script>
import { Chat } from 'src/apis'
import SliderDetails from './SliderDetails.vue'
import ReservationForm from './ReservationForm.vue'
import RestaurantForm from './RestaurantForm.vue'
import ContactForm from './ContactForm.vue'
import ConfirmForm from './ConfirmForm.vue'
import CountryCodeForm from './CountryCodeForm.vue'
import ImageListSelector from './ImageListSelector.vue'
import RentalCarForm from './RentalCarForm.vue'
import SearchAreaForm from './SearchAreaForm.vue'
import style from './scss/_pages.scss'
import IconBack from 'assets/icons/keyboard-backspace.svg?inline'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useSettingsStore } from 'Store/settings'
import { useColorsStore } from 'Store/colors'
import { useDetailsPageStore } from 'Store/details-page'

export default {
  name: 'DetailsPage',

  components: {
    IconBack,
    SliderDetails,
    ReservationForm,
    RestaurantForm,
    ContactForm,
    ConfirmForm,
    CountryCodeForm,
    ImageListSelector,
    SearchAreaForm,
    RentalCarForm
  },

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      settingsStore: useSettingsStore(),
      colorsStore: useColorsStore(),
      detailsPageStore: useDetailsPageStore()
    }
  },

  data() {
    return { style }
  },
  computed: {
    headerText() {
      const chat = this.detailsPageStore.chat
      return chat && chat.message_rich && chat.message_rich.heading
    },
    headerColor() {
      return { color: this.colorsStore.textColor }
    },
    error() {
      const chat = this.detailsPageStore.chat
      const error = chat && chat.message_rich && chat.message_rich.error
      return error ? (Array.isArray(error) ? error : [error]) : null
    }
  },
  methods: {
    clickBack() {
      if (this.detailsPageStore.isDetailsPageShown === 'ReservationForm') {
        this.quitServerFlow()
      }
      this.detailsPageStore.closeDetailsPageShown()
      this.bottomPanelStore.setBottomPanelComponent()
    },
    quitServerFlow() {
      const menuItems = this.settingsStore.getSettings[this.$i18n.locale].menu_items
      if (!menuItems) return

      const options = {
        messageAction: 'back',
        resetValue: true,
        useAi: true
      }
      const backText = menuItems.find((mi) => mi.action === 'back').text
      Chat.sendMessage(backText, options)
    }
  }
}
</script>
